/*
 * @Author: wsx
 * @Date: 2022-01-23 15:48:50
 * @LastEditTime: 2022-01-23 15:50:42
 * @LastEditors: your name
 * @Description:  告警中心
 */
import request from "@/utils/request";


// 获取时间
export const getTime = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/af/ntp/info/get_time",
    method: "get",
    params: data,
    ...loadingObj
  });
};

// 设置本机时间
export const setLocalhostTime = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/af/ntp/info/set_localhost_time",
    method: "get",
    params: data,
    ...loadingObj
  });
};